import * as Yup from "yup";

import { AddressKeys, CountryKeys, OrganisationKeys, validationMsgs } from "@sso/constant";
import { Country } from "@sso/types";

export const organisationSchemaValidation = Yup.object({
  [OrganisationKeys.NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(50, validationMsgs.maxlength(50)),
  [OrganisationKeys.BILLING_EMAIL]: Yup.string()
    .required(validationMsgs.required)
    .email(validationMsgs.email)
    .max(100, validationMsgs.maxlength(100)),
  [OrganisationKeys.ADDRESS]: Yup.object({
    [AddressKeys.FIRST_LINE]: Yup.string().required(validationMsgs.required),
    [AddressKeys.SECOND_LINE]: Yup.string().nullable(),
    [AddressKeys.CITY]: Yup.string().required(validationMsgs.required),
    [AddressKeys.STATE]: Yup.string().nullable(),
    [AddressKeys.POSTCODE]: Yup.string().nullable(),
    [AddressKeys.COUNTRY_ID]: Yup.string().required(validationMsgs.required),
    [AddressKeys.COUNTRY]: Yup.object(),
  }),
  [OrganisationKeys.PHONE]: Yup.string().max(20, validationMsgs.maxlength(25)),
  [OrganisationKeys.TRANSACTION_CURRENCY_CODE]: Yup.string().max(20, validationMsgs.maxlength(25)),
  [OrganisationKeys.VAT_NUMBER]: Yup.string()
    .max(20, validationMsgs.maxlength(20))
    .when(`${OrganisationKeys.ADDRESS}.${AddressKeys.COUNTRY_ID}`, {
      is: (countryId: string) => !countryId,
      then: Yup.string().required("Please select a country"),
    })
    .when(`${OrganisationKeys.ADDRESS}.${AddressKeys.COUNTRY}`, {
      is: (country: Country) => country?.[CountryKeys.IS_EU] || country?.[CountryKeys.COUNTRY_CODE] === "GB",
      then: Yup.string().required("VAT number is required for UK and EU based organisations"),
    }),
});
